import { ILoginAuth } from "@fl/shared/src/types/usuarios";
import React, { createContext, useContext, useState } from "react";
import StorageItems from "../storage";

interface AuthContextType {
  authToken: ILoginAuth | null;
  setAuthToken: (token: ILoginAuth | null) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType>({
  authToken: null,
  setAuthToken: (token: ILoginAuth | null) => {},
  logout: () => {},
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [authToken, setAuthToken] = useState<ILoginAuth | null>(
    new StorageItems().get("authToken")
  );

  const saveAuthToken = (token: ILoginAuth | null) => {
    if (token) {
      new StorageItems().set("authToken", token);
    } else {
      new StorageItems().remove("authToken");
    }
    setAuthToken(token);
  };

  const logout = () => {
    new StorageItems().clear();
    setAuthToken(null);
  };

  return (
    <AuthContext.Provider
      value={{ authToken, setAuthToken: saveAuthToken, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};
